// 旅游资源管理

export default [{
        path: '/resourcesManage/home',
        meta: {
            title: '旅游资源管理'
        },
        component: () =>
            import ('../../pages/resourcesManage/views/home'),
        children: [
            {
                path: '/resourcesManage/home',
                redirect: '/resourcesManage/home/profile'
            },
            {
                path: 'profile',
                component: () =>
                    import ('../../pages/resourcesManage/views/home/profile/index.vue'),
                meta: {
                    keepAlive: false,
                    title: '旅游资源管理'
                }
            },
            {
                path: 'distribution',
                component: () =>
                    import ('../../pages/resourcesManage/views/home/distribution/index.vue'),
                meta: {
                    title: '旅游资源管理'
                }
            },
            {
                path: 'analysis',
                component: () =>
                    import ('../../pages/resourcesManage/views/home/analysis/index.vue'),
                meta: {
                    keepAlive: false,
                    title: '旅游资源管理'
                }
            }
        ]
    },
    {
        path: '/resourcesManage/directories',
        meta: {
            title: '资源名录'
        },
        component: () =>
            import ('../../pages/resourcesManage/views/directories/index.vue')
    },
    {
        path: '/resourcesManage/directoriesDetele',
        meta: {
            title: '资源单体详情'
        },
        component: () =>
            import ('../../pages/resourcesManage/views/directoriesDetele/index.vue')
    },
    {
        path: '/resourcesManage/search',
        meta: {
            title: '搜索'
        },
        component: () =>
            import ('../../pages/resourcesManage/views/search/index.vue')
    }
]
